import { useCreateCampaign } from '@copilot/common/hooks/campaign';
import { useAllCampaignsPage } from './hooks/useAllCampaignsPage';
import { AllCampaignsPage } from './allCampaignsPage';

/**
 * Smart component for all campaigns page
 * Responsible for handling data fetching and state updates
 * @param props
 * @returns
 */
export function AllCampaignsPageContainer() {
    const {
        organizationId,
        isLoading,
        campaignSummaryData,
        canEditCampaigns,
        showTeamMembers,
        searchTerm,
        campaignFilterType,
        teamMemberFilters,
        onCampaignFilterChanged,
        onTeamMembersFilterChanged,
        onSearchTermChanged,
        onDeleteCampaign,
        isError,
    } = useAllCampaignsPage();

    return (
        <AllCampaignsPage
            canEditCampaigns={canEditCampaigns}
            showTeamMembers={showTeamMembers}
            campaignSummaryData={campaignSummaryData}
            isLoading={isLoading}
            isError={isError}
            organizationId={organizationId}
            campaignFilterType={campaignFilterType}
            onCampaignFilterChanged={onCampaignFilterChanged}
            teamMembersFilter={teamMemberFilters}
            onTeamMembersFilterChanged={onTeamMembersFilterChanged}
            onCreateNewCampaign={useCreateCampaign()}
            onDeleteCampaign={(campaignId) => void onDeleteCampaign(campaignId)}
            campaignNameSearchTerm={searchTerm}
            onCampaignNameSearchTermChanged={onSearchTermChanged}
        />
    );
}
